export const tableStyles = {
  offersListHeaderStyles: {
    tableStyle: {
      'font-size': '1.5rem',
      'border-collapse': 'collapse',
      'width': '100%',
      'margin-left': '1.5rem'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(246,246,230)'
    },
    trStyle: {
      'border': '1px solid #cecece',
      'font-size': '1.3rem'
    },
    topHeaderStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(230, 232, 246)'
    }
  },
  offersListDataStyle: {
    tableStyle: {
      'font-size': '1.5rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'white'
    },
    trStyle: {
      'border': '1px solid #cecece',
      'font-size': '1.3rem'
    },
    editBoxWidthFull: {
      'display': 'inline-block',
      'width': '100%',
      'border': 'none',
      'height': '33px',
      'padding-left': '1rem',
      'padding-right': '1rem'
    },
    topHeaderStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(230, 232, 246)'
    }
  },
  offerZoneListHeaderStyle: {
    headerTableStyle: {
      'font-size': '1.5rem',
      'border-collapse': 'collapse',
      'width': '100%',
      'position': 'relative'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '0.8rem',
      'background-color': 'rgb(246,246,230)',
      'width': '25%',
      'word-wrap': 'break-word',
      'border': '1px solid #cecece'
    },
    trStyle: {
      'border': '1px solid #cecece',
      'width': '100%'
    },
    thStyle: {
      'border': '1px solid #cecece',
      'width': '25%',
      'word-wrap': 'break-word',
      'padding': '1rem 1rem'
    },
    tableContainerStyle: {
      'width': '100%'
    },
    editableLabel: {
      'display': 'inline-block',
      'width': '90%'
    },
    editableEditBox: {
      'display': 'inline-block',
      'cursor': 'pointer'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/charts-simulation/tableStyles.js